import React, { useContext, useEffect, useState } from "react";

import classNames from "classnames";
import isEmpty from "lodash.isempty";
import { observer } from "mobx-react";
import Image from "next/legacy/image";
import { useRouter } from "../../shared/hooks/useNavigation";
import styled from "styled-components";

import ComponentContext from "../../contexts/ComponentContext";
import { useStores } from "../../contexts/StoreContext";
import apiInstance from "../../services/api";
import BlogSidebar from "../BlogSidebar/BlogSidebar";
// eslint-disable-next-line import/no-cycle
import CustomPage from "../CustomPage/CustomPage";
import VerticalJobCards from "../VerticalJobCards/VerticalJobCards";

const dateOptions = {
  day: "numeric",
  month: "long",
  year: "numeric",
};

const StyledCoverImageHero = styled.div`
  width: 100%;
  height: ${({ postCoverHeight }) => postCoverHeight || "50vh"};
`;

const StyledCoverImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`;

const StyledCoverImage = styled(Image)`
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: relative !important;
`;

function Post() {
  const [vacancies, setVacancies] = useState([]);
  const router = useRouter();
  const { blogStore } = useStores();
  const {
    showDescription,
    enableSidebar,
    showVerticalJobList,
    verticalJobsCount,
    showPostCoverImage,
    postCoverHeight,
  } = useContext(ComponentContext);

  const { currentPost } = blogStore;
  const author = currentPost.post_authors?.[0]?.authorName;
  const coverImage = currentPost.cover?.url;
  const isCoverImage = showPostCoverImage && !isEmpty(coverImage);

  useEffect(() => {
    apiInstance
      .getVacancies(
        {},
        {
          limit: verticalJobsCount,
          sort: [
            {
              field: "createdDateTime",
              order: "DESC",
            },
          ],
          start: 0,
        }
      )
      .then((response) => setVacancies(response.data.results));
  }, []);

  if (isEmpty(currentPost)) {
    return null;
  }

  const date = new Date(currentPost.createdAt).toLocaleString(
    router.locale,
    dateOptions
  );

  const postClassname = classNames("blog-post", {
    "col-md-8 col-lg-9": showVerticalJobList,
    "col-md-9 col-lg-10": enableSidebar,
  });

  return (
    <>
      {isCoverImage && (
        <StyledCoverImageHero postCoverHeight={postCoverHeight}>
          <StyledCoverImageWrapper>
            <StyledCoverImage alt={currentPost?.title} fill src={coverImage} />
          </StyledCoverImageWrapper>
        </StyledCoverImageHero>
      )}
      <div className="row">
        <div className={postClassname}>
          <div className="px-2 mb-2 mt-4">
            <h1>{currentPost?.title}</h1>
            <div className="d-flex mb-2">
              {author && <span className="me-2">{author}</span>}
              <span>{date}</span>
            </div>
            {showDescription && <p>{currentPost.description}</p>}
          </div>
          <CustomPage pageAttributes={currentPost} />
        </div>
        {enableSidebar && (
          <div className="sidebar-wrapper col-md-3 col-lg-2">
            <BlogSidebar />
          </div>
        )}
        {showVerticalJobList && (
          <div className="vertical-jobs-wrapper col-md-4 col-lg-3 ">
            <VerticalJobCards vacancies={vacancies} />
          </div>
        )}
      </div>
    </>
  );
}

export default observer(Post);
